import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import getAdminFieldsService from '../services/adminFields';
import restrictedFieldsService from '../services/restrictedFields';

const RestrictedFields = () => {
  const [passwordPop, setPasswordPop] = useState(true);
  const [password, setPassword] = useState();
  const [error, setError] = useState();
  const [fields, setFields] = useState();
  const [fieldName, setFieldName] = useState('');
  const [restrictedFields, setRestrictedFields] = useState();
  const navigate = useNavigate();

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    const enteredPassword = password;
    setPasswordPop(false);
    fetchFields(enteredPassword);
  };

  const fetchFields = async (enteredPassword) => {
    try {
      const fields = await getAdminFieldsService.getAdminFields();
      const restrictedFieldsResponse =
        await restrictedFieldsService.getFields();
      setFields(fields);
      setRestrictedFields(
        restrictedFieldsResponse.fields ? restrictedFieldsResponse.fields : []
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleAdd = async () => {
    if (fieldName) {
      // Check if the fieldName already exists in restrictedFields
      const isDuplicate = restrictedFields.some(
        (field) => field.name === fieldName
      );

      if (isDuplicate) {
        alert('Already added');
        return; // Exit the function early if a duplicate is found
      }

      try {
        const newField = {
          name: fieldName,
        };
        await restrictedFieldsService.addField({ newField, password });
        fetchFields(password); // Refresh the fields
      } catch (error) {
        console.log(error);
        alert('Something went wrong while adding the field.');
      }
    }
  };

  const handleDelete = async (id) => {
    try {
      await restrictedFieldsService.deleteField({ id, password });
      fetchFields(password);
    } catch (error) {
      console.log(error);
      alert('something went wrong while deleting', error);
    }
  };

  const handleClosePasswordPopup = () => {
    setPassword('');
    setError('');
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-start justify-center p-6">
      {!passwordPop ? (
        <div
          className="
          relative
          w-full
          max-w-[360px]
          sm:max-w-xl
          md:max-w-2xl
          lg:max-w-4xl
          bg-white
          rounded-xl
          shadow-md
          px-4
          py-5
          sm:px-6
          sm:py-6
          space-y-5
        "
        >
          <div className="space-y-3">
            <button
              onClick={() => navigate(-1)}
              aria-label="Close"
              className="
              absolute
              top-3
              right-3
              sm:top-4
              sm:right-4
              p-1.5
              rounded-md
              text-gray-500
              hover:text-gray-800
              hover:bg-gray-100
              transition
              focus:outline-none
              focus:ring-2
              focus:ring-blue-500
            "
            >
              <X size={18} />
            </button>

            <h2
              className="
            text-lg
            sm:text-xl
            md:text-2xl
            font-semibold
            text-gray-800
            text-center
            sm:text-center
          "
            >
              Seller Restricted Fields
            </h2>
          </div>

          <div className="flex flex-col gap-3 sm:gap-4 lg:flex-row lg:items-end">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select the field to be restricted
              </label>

              <select
                onChange={(e) => setFieldName(e.target.value)}
                className="
                  w-full
                  px-3
                  py-2
                  border
                  border-gray-300
                  rounded-md
                  text-sm
                  focus:outline-none
                  focus:ring-2
                  focus:ring-blue-500
                  max-h-[44px]
                "
              >
                <option value="">Select</option>
                {fields &&
                  fields.map((field) => (
                    <option key={field.name} value={field.name || ''}>
                      {field.name || ''}
                    </option>
                  ))}
              </select>
            </div>

            <button
              onClick={handleAdd}
              className="
                w-full
                lg:w-auto
                px-6
                py-2
                bg-blue-600
                text-white
                rounded-md
                text-sm
                font-medium
                hover:bg-blue-700
                transition
              "
            >
              Make seller-only
            </button>
          </div>

          {restrictedFields && (
            <div className="pt-2">
              <h3 className="text-sm font-semibold text-gray-600 mb-3">
                Restricted Fields
              </h3>

              <div className="space-y-2 max-h-[320px] overflow-y-auto pr-1">
                {restrictedFields.map((field) => (
                  <div
                    key={field._id}
                    className="
                      flex
                      justify-between
                      items-center
                      gap-3
                      px-4
                      py-2
                      bg-gray-50
                      border
                      border-gray-200
                      rounded-md
                    "
                  >
                    <span className="text-sm text-gray-800 truncate">
                      {field.name}
                    </span>

                    <button
                      onClick={() => handleDelete(field._id)}
                      className="
                        text-sm
                        text-red-600
                        hover:text-red-700
                        font-medium
                        whitespace-nowrap
                      "
                    >
                      Delete
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="relative bg-white w-[300px] px-5 py-5 rounded-xl shadow-lg text-center">
            <h2 className="text-[20px] font-semibold text-[#1f2937] mt-4 mb-4">
              Enter Master Password
            </h2>

            <span
              onClick={handleClosePasswordPopup}
              role="button"
              aria-label="Close"
              className="
                  absolute
                  top-3
                  right-3
                  text-gray-600
                  text-xl
                  cursor-pointer
                  hover:text-gray-800
                  select-none
                "
            >
              ✕
            </span>

            <form onSubmit={handlePasswordSubmit} className="space-y-4">
              <input
                type="password"
                placeholder="Master Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="
                  w-full
                  h-[44px]
                  px-4
                  border
                  border-[#d1d5db]
                  rounded-md
                  text-[15px]
                  text-gray-700
                  placeholder-gray-400
                  focus:outline-none
                  focus:ring-2
                  focus:ring-gray-600
                "
              />

              <button
                type="submit"
                className="
                  w-full
                  h-[44px]
                  bg-[#4CAF50]
                  text-white
                  text-[15px]
                  font-medium
                  rounded-md
                  hover:bg-[#43a047]
                  transition
                "
              >
                Submit
              </button>
            </form>

            {error && <p className="mt-3 text-sm text-red-600">{error}</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default RestrictedFields;
